// extracted by mini-css-extract-plugin
module.exports = {"success-icon":"Received_success-icon__31hOO","group":"Received_group__1ap1j"};